export default {
  en: {
    why_we_recommend_the_companies_plan:
      "Why we recommend the Premium Plan for Businesses",
    companies_plan_description_1:
      "The Premium Plan is the best choice for businesses that want to manage their team members and projects efficiently. With advanced analytics and detailed reports, you can gain insights into your company and improve your workflow.",
    companies_plan_description_2:
      "For businesses, time is money. Our Premium Plan ensures that you can track every minute spent on projects and tasks, allowing you to optimize your team's productivity and efficiency. With our advanced features, you can focus on what matters most - growing your business.",
    get_started_with_premium: "Get started with the Premium Plan today!",
  },
  de: {
    why_we_recommend_the_companies_plan:
      "Warum wir den Premium-Tarif für Unternehmen empfehlen",
    companies_plan_description_1:
      "Der Premium-Tarif ist die beste Wahl für Unternehmen, die ihre Teammitglieder und Projekte effizient verwalten möchten. Mit fortschrittlichen Analysen und detaillierten Berichten kannst du Einblicke in dein Unternehmen gewinnen und deinen Workflow verbessern.",
    companies_plan_description_2:
      "Für Unternehmen ist Zeit Geld. Unser Premium-Tarif stellt sicher, dass du jede Minute, die auf Projekte und Aufgaben verwendet wird, verfolgen kannst, um die Produktivität und Effizienz deines Teams zu optimieren. Mit unseren fortschrittlichen Funktionen kannst du dich auf das konzentrieren, was am wichtigsten ist – das Wachstum deines Unternehmens.",
    get_started_with_premium: "Starte noch heute mit dem Premium-Tarif!",
  },
};
